
import vue from 'vue'
import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import {
initWxJSSDK,
loadMapMarkerTerminals,
getAllNearTerminalList,
getNearTerminal,
appointmentTerminal,
getTerminalAppointmentTime
} from '../../../common/js/api.js'
import {
getCookie,
setCookie,
removeCookie
} from '../../../common/js/utils.js'
import {
TMap
} from '../../../common/js/map.js'
import { wxORzfb } from '../../../common/js/config.js';
export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle
},
methods: {
init() {
let self = this
if (self.isInit) {
return
}
if (self.list.length == 0 || !self.myLocation) {
return
}
self.lineCount = 0
for (var i = 0; i < self.list.length; i++) {
let directionsService = new qq.maps.DrivingService({
complete: function(response) {


self.lineCount++
if (response.detail.bounds.lat.minY < self.mapBounds.lat.minY) {
self.mapBounds.lat.minY = response.detail.bounds.lat.minY
}
if (response.detail.bounds.lat.maxY > self.mapBounds.lat.maxY) {
self.mapBounds.lat.maxY = response.detail.bounds.lat.maxY
}
if (response.detail.bounds.lng.minX < self.mapBounds.lng.minX) {
self.mapBounds.lng.minX = response.detail.bounds.lng.minX
}
if (response.detail.bounds.lng.maxX > self.mapBounds.lng.maxX) {
self.mapBounds.lng.maxX = response.detail.bounds.lng.maxX
}
let directions_routes = response.detail.routes
let route = directions_routes[0]
let polyline = new qq.maps.Polyline({
path: route.path,
strokeColor: self.randomColor(), //'#3893F9',
strokeWeight: 3,
map: self.map
})
if (self.lineCount == self.list.length) {
self.resetBound()



}
}
})
self.directionsServiceList.push(self.directionsService)
directionsService.setPolicy(qq.maps.DrivingPolicy['LEAST_TIME'])
directionsService.search(
new qq.maps.LatLng(
self.myLocation.latitude,
self.myLocation.longitude
),
new qq.maps.LatLng(self.list[i].latitude, self.list[i].longitude)
)
}
for (var i = 0; i < self.list.length; i++) {
self.terminals.push({
gps: new qq.maps.LatLng(
self.list[i].latitude,
self.list[i].longitude
),
location: self.list[i].location,
status: self.list[i].status,
online: self.list[i].extInfo.online,
useAll: self.list[i].useAll,
terminalId: self.list[i].sid,
terminalCode: self.list[i].terminalId,
})
}
if (self.terminals) {
for (i in self.terminals) {

var icon = '/static/images/box_online.png'
if (self.terminals[i].online == 0) {
icon = '/static/images/box_offline.png'
} else if (self.terminals[i].useAll == 1) {
icon = '/static/images/box_full.png'
}
self.addMarker(
self.terminals[i],
new qq.maps.MarkerImage(
icon,
new qq.maps.Size(32, 32),
new qq.maps.Point(0, 0),
new qq.maps.Point(16, 32),
new qq.maps.Size(32, 32)
)
)
}
}

var opt = {
position: new qq.maps.LatLng(
self.myLocation.latitude,
self.myLocation.longitude
),
map: self.map
}
if (icon) {
opt.icon = new qq.maps.MarkerImage(
'/static/images/icons/i_start.png',
new qq.maps.Size(32, 32),
new qq.maps.Point(0, 0),
new qq.maps.Point(32, 32),
new qq.maps.Size(32, 32)
)

}
var marker = new qq.maps.Marker(opt)
self.isInit = true
},
randomColor() {
return '#' + Math.floor(Math.random() * 0xffffff).toString(16)
},
resetBound() {
let self = this






self.map.fitBounds(
new qq.maps.LatLngBounds(
new qq.maps.LatLng(self.mapBounds.lat.minY, self.mapBounds.lng.minX),
new qq.maps.LatLng(self.mapBounds.lat.maxY, self.mapBounds.lng.maxX)
)
)
},
checkBox(v) {
let self = this;
if(self.entityList && self.entityList.size[v - 1] == 1) return
self.appointmentBoxEntity.boxSize = v;
},
getAllNearTerminalList() {
let self = this
self.pageInfo.longitude = self.myLocation.longitude
self.pageInfo.latitude = self.myLocation.latitude
getAllNearTerminalList({
data: self.pageInfo
}).then(function(data) {
let content = data.Content
for (var i = 0; i < content.length; i++) {
if (content[i].boxType == 2) {
let store = content[i].boxStoreInfo.split(",");
let specification = content[i].boxSpecification.split(",");
let appointment = content[i].boxAppointment.split(",");
let terminalSource = [];
let size = [1,1,1]
for (var j = 0; j < store.length; j++) {
const terminalSourceList = {
store:store[j].split(":")[1],
specification: specification[j].split(":")[1],
appointment: appointment[j].split(":")[1]
}
if(terminalSourceList.appointment == 0 && terminalSourceList.store == 0) {
if(terminalSourceList.specification == 1) {
size[0] = 0
}
if(terminalSourceList.specification == 2) {
size[1] = 0
}
if(terminalSourceList.specification == 3) {
size[2] = 0
}
}
if(terminalSourceList.appointment == 1){
self.isAppointmentBox = true
}
terminalSource.push(terminalSourceList)
}

content[i].size = size
content[i].terminalSource = terminalSource
self.list.push(content[i])
}
}
self.listShow = true
setTimeout(self.init, 500)
})
},
getTerminalAppointmentTime() {
const self = this
getTerminalAppointmentTime({}).then(function(data){
self.appointmentTime = parseFloat(data.Content/60).toFixed(2)
})
},
getLocation() {
this.initLocation()
},
initLocation() {
let self = this
self.$wechat.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res)

},
success: function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
var speed = res.speed 
var accuracy = res.accuracy 
setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.myLocation = {
latitude: latitude,
longitude: longitude
}
self.getTerminalAppointmentTime()
self.getAllNearTerminalList()
}
})
},
initZfbLocation() {
const self = this
ap.getLocation(function(res) {
var latitude = res
.latitude // 纬度，浮点数，范围为90 ~ -90
var longitude = res.longitude 


setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.pageInfo.latitude =  latitude
self.pageInfo.longitude = longitude
self.getList()
});
},
setCenter(_center) {
try {
this.map.panTo(_center)
} catch (e) {}
},
addMarker(terminal, icon) {
let self = this
var opt = {
position: terminal.gps,
map: self.map
}
if (icon) {
opt.icon = icon
}
var marker = new qq.maps.Marker(opt)
marker.terminalId = terminal.terminalId
marker.terminalCode = terminal.terminalCode
marker.location = terminal.location
marker.status = terminal.status
marker.useAll = terminal.useAll
marker.lat = terminal.gps.lat
marker.lng = terminal.gps.lng
qq.maps.event.addListener(marker, 'click', function(event) {
console.log(event.target)
const target = event.target
self.routeTerminal(target.lat, target.lng, target.location)
})

},
appointmentBox(item,index) {
console.log(item)
this.entityList = item
this.selectTerminalIndex = index
this.appointmentBoxEntity.terminalId = item.sid
this.openAppointmentPopup = true

},
confirmAppointment() {
const self = this
if(self.appointmentBoxEntity.boxSize == '') {
self.$vux.toast.text('请选择格子大小')
return
}
appointmentTerminal({data:this.appointmentBoxEntity}).then(function(data) {
self.openAppointmentPopup = false
self.isAppointmentBox = true
self.$vux.toast.text('成功预约格子')
}).catch(function() {
self.openAppointmentPopup = false
})
},
routeTerminal(latitude, longitude, location) {
let self = this
if(wxORzfb == 'wx') {
self.$wechat.openLocation({
latitude: latitude, // 纬度，浮点数，范围为90 ~ -90
longitude: longitude, // 经度，浮点数，范围为180 ~ -180。
name: '回收箱位置', // 位置名
address: location, // 地址详情说明
scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
infoUrl: '' 
})
} else if(wxORzfb == 'zfb') {
ap.openLocation({
longitude: longitude,
latitude: latitude,
name: '回收箱位置',
address: location,
scale:14
});
}
},
},
watch: {},
data() {
return {
lineCount: 0,
mapBounds: {
lat: {
minY: 999,
maxY: 0
},
lng: {
minX: 999,
maxX: 0
}
},
myLocation: {
latitude: '',
longitude: ''
},
center: {},
map: {},
directionsService: null,
directionsServiceList: [],
isInit: false,
dataSource: [],
terminals: [],
currentTerminal: {
extInfo: {}
},
isPopup: false,
listShow: false,
serialNumber: 0,
times: 0,
list: [],
pageInfo: {
pageIndex: 1,
pageSize: 3
},
appointmentBoxEntity: {
terminalId:'',
boxSize:''
},
entityList:null,
selectTerminalIndex:-1,
openAppointmentPopup:false,
appointmentTime:'',
isAppointmentBox:false
}
},
created() {
const self = this
const query = this.$route.query;

const longitude = query.longitude
const latitude = query.latitude
if(longitude && latitude) {
setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.myLocation = {
latitude: latitude,
longitude: longitude
}
self.getTerminalAppointmentTime()
self.getAllNearTerminalList()
}
},
mounted() {
let self = this
initWxJSSDK()
var longitude = getCookie('longitude')
var latitude = getCookie('latitude')
if (!latitude) {
latitude = 39.916527
}
if (!longitude) {
longitude = 116.397128
}
if(wxORzfb == 'wx') {
TMap('').then(qq => {


self.map = new qq.maps.Map(document.getElementById('map-container'), {

center: new qq.maps.LatLng(latitude, longitude),
zoom: 10,
disableDefaultUI: true
})





















})
if(!self.myLocation.latitude && !self.myLocation.longitude) {
vue.wechat.ready(function(res) {
self.initLocation()
})
}
} else if(wxORzfb == 'zfb'){

self.initZfbLocation()
}
}
}



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/box.vue